"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeModalRouteAction = exports.getModalRouteActionValue = exports.getModalActionKey = exports.makeActionRouteParams = exports.parseActionRouteParams = exports.getActionRouteParams = exports.getActionKey = exports.RouteAction = void 0;
const query_params_util_1 = require("../../@common/util/query-params-util");
var RouteAction;
(function (RouteAction) {
    RouteAction["ACTION"] = "action";
    RouteAction["MODAL_TYPE"] = "view";
})(RouteAction = exports.RouteAction || (exports.RouteAction = {}));
/* action helpers */
const getActionKey = () => `${RouteAction.ACTION}-`;
exports.getActionKey = getActionKey;
const getActionRouteParams = (routeParams = {}) => Object.entries(routeParams).reduce((acc, [key, value]) => {
    return Object.assign(Object.assign({}, acc), { [key.replace(exports.getActionKey(), '')]: value });
}, {});
exports.getActionRouteParams = getActionRouteParams;
const parseActionRouteParams = (locationSearch) => {
    return exports.getActionRouteParams(query_params_util_1.parseQueryParams(locationSearch)) || {};
};
exports.parseActionRouteParams = parseActionRouteParams;
const buildActionRouteParamsFromRouteParams = (routeParams) => {
    if (!Object.keys(routeParams).length)
        return routeParams;
    return Object.entries(routeParams).reduce((acc, [key, value]) => {
        return Object.assign(Object.assign({}, acc), { [`${exports.getActionKey()}${key}`]: value });
    }, {});
};
const makeActionRouteParams = ({ locationSearch, actionKeyFn, action = '', routeParams = {}, actionParamKeyFn = exports.getActionKey }) => {
    const result = Object.assign(Object.assign(Object.assign({}, query_params_util_1.parseQueryParams(locationSearch)), (action && actionKeyFn && { action: actionKeyFn(action) })), buildActionRouteParamsFromRouteParams(routeParams));
    // if no action -> remove all action params while preserving other route params
    if (!action && result.action) {
        delete result.action;
        Object.keys(result).forEach(x => x.includes(actionParamKeyFn()) && delete result[x]);
    }
    return query_params_util_1.buildSearchQueryParams(result);
};
exports.makeActionRouteParams = makeActionRouteParams;
/* Modal action helpers */
const getModalActionKey = () => `-${RouteAction.MODAL_TYPE}`;
exports.getModalActionKey = getModalActionKey;
const getModalRouteActionValue = (action) => action.replace(exports.getModalActionKey(), '');
exports.getModalRouteActionValue = getModalRouteActionValue;
const makeModalRouteAction = (action) => {
    return `${action}${exports.getModalActionKey()}`;
};
exports.makeModalRouteAction = makeModalRouteAction;
